import { render } from "./ViewLab.vue?vue&type=template&id=85aa08c6"
import script from "./ViewLab.vue?vue&type=script&lang=js"
export * from "./ViewLab.vue?vue&type=script&lang=js"

import "./ViewLab.vue?vue&type=style&index=0&id=85aa08c6&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/topdog/labs/ViewLab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85aa08c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85aa08c6', __exports__)) {
    console.log('reload')
    api.reload('85aa08c6', __exports__)
  }
  
  module.hot.accept("./ViewLab.vue?vue&type=template&id=85aa08c6", () => {
    console.log('re-render')
    api.rerender('85aa08c6', render)
  })

}


export default __exports__